import { createSlice } from '@reduxjs/toolkit';

import { getSupplyOrders, updateProductionStatus } from '../../apis';

export const ProductionUnitSlice = createSlice({

    name: 'productionUnitPlatform',
    initialState: {
        isLoading: false,
        data : [],
        error: '',
        updateProductionSuccess: false
    },

    reducers: {
      resetUpdateProductionSuccess: (state, action) => {
        return {
          ...state,
          updateProductionSuccess: action.payload
        }
      },
      clearErrorState: (state, action) => {
        return {
          ...state,
          error: action.payload
        }
      }
    },

    extraReducers: (builder) => {
        builder.addCase(getSupplyOrders.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getSupplyOrders.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getSupplyOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateProductionStatus.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(updateProductionStatus.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateProductionSuccess = true
        })
        builder.addCase(updateProductionStatus.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { resetUpdateProductionSuccess, clearErrorState } = ProductionUnitSlice.actions


export default ProductionUnitSlice.reducer